import { Injectable } from '@angular/core';

interface ObjectName {
    firstName?: string;
    lastName?: string;
    name?: string;
}

@Injectable({
    providedIn: 'root'
})
export class ObjectUtilsService {
    buildName<Type extends ObjectName>(object: Type): Type {
        object.name = `${object.firstName} ${object.lastName}`;
        return object;
    }
    buildNames<Type extends ObjectName>(objects: Type[]): Type[] {
        return objects.map((object) => this.buildName(object));
    }
}
